'use client'
import { getWalletBookWallet } from '@dynamic-labs/wallet-book';

const applyLinksOverrides = (walletBook, wallets) => wallets.map((wallet) => {
    const metadata = getWalletBookWallet(walletBook, wallet.key, wallet.walletFallback);
    if (metadata.switchNetworkOnlyFromWallet !== undefined) {
        wallet.switchNetworkOnlyFromWallet = metadata.switchNetworkOnlyFromWallet;
    }
    return wallet;
});

export { applyLinksOverrides };
